import { css } from './css-in-js';
import { theme } from './theme';

export const normalizeCSS = css`
  *,
  *:after,
  *:before {
    box-sizing: border-box;
  }

  html {
    -webkit-text-size-adjust: 100%;
    line-height: 1.15;
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    background-color: ${theme.colors.build.lightDark1};
    font-family: ${theme.fonts.primary};
  }

  main {
    display: block;
  }

  #maze-contextual-widget-host,
  #maze-media-host {
    z-index: 1200 !important;
  }

  p {
    font-family: ${theme.fonts.primary};
    margin: 0px;
  }
`;
